<template>
  <div class="modal-bg" v-show="show" @keyup.enter="hideModal">
    <div class="modal-container">
      <div @click="closeTool" class="goback">
        <i class="el-icon-close"></i>
      </div>
      <div class="modal-header">
        设计工具登录系统
      </div>
      <div class="modal-main">
        <el-row :gutter="0" type="flex"  style="margin-top: 10%;margin-left: 5%">
           <el-col :span="3"><div class="titleface" style="margin-top: 8%">账号：</div></el-col>
           <el-col :span="18">
             <el-input v-model="form.username" placeholder="请输入账号" size="mini">
               <template slot="prepend"><i class="el-icon-user-solid"></i></template>
             </el-input>
           </el-col>
      </el-row>
        <el-row :gutter="0" type="flex"  style="margin-top: 5%;margin-left: 5%">
          <el-col :span="3"><div class="titleface" style="margin-top: 8%">密码：</div></el-col>
          <el-col :span="18"><el-input v-model="form.password" placeholder="请输入密码" size="mini" show-password>
            <template slot="prepend"><i class="el-icon-s-goods"></i></template>
          </el-input>
          </el-col>
        </el-row>
        <!--<el-row :gutter="0" type="flex"  style="margin-top: 5%;margin-left: 2%">
          <el-col :span="5"><div class="titleface" style="margin-top: 8%">验证码：</div></el-col>
        &lt;!&ndash;  <el-col :span="16"><el-input v-model="input" placeholder="请输入密码" size="mini"></el-input>&ndash;&gt;
          </el-col>
        </el-row>-->
      </div>
      <div class="modal-footer">
        <el-button type="info"  @click="hideModal" size="small">登录</el-button>
        <el-button type="info" @click="submit" size="small">注册</el-button>
      </div>
    </div>
  </div>
</template>

<script>
  import service from '../../service/authorityService'
export default {
  name: 'ToolLogin',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  components: {

  },
  data () {
    return {
       form:{
         username:'',
         password:''
       },
    }
  },
  computed: {

  },
  mounted () {

  },
  methods: {
    hideModal() {
     // this.$emit('hideModal')
      if (this.form.username !== '' && this.form.password !== '') {
        let name  = this.form.username
        service.login(this.form).then(res => {
          localStorage.setItem('Authorization', res.token)
          localStorage.setItem('username',this.form.username)
          let userInfo = JSON.stringify(res)
          localStorage.setItem('userInfo', userInfo)
          this.$emit('hideModal')
          this.form.username = ""
          this.form.password = ""
          this.$router.push({name: 'Designtool'})
        }).catch(err => {
          this.form.username = ""
          this.form.password = ""
          this.$Message.error(err.message)
        })
      }else {
        this.$Message.error('用户名或密码不能为空')
      }
    },
    submit() {
      //this.$emit('submit')
      this.$router.push({name: 'ToolRegister'})
    },
    closeTool(){
      this.$emit('submit')
    },
  }
}
</script>
<style scoped>
  .modal-bg{
    position: absolute;
    z-index: 111;
    width: 100%;
    height: 100%;
    overflow: hidden;
  }
  .modal-container{
    width: 400px;
    height: 300px;
    background-color: rgba(35, 33, 34, 0.84);
    border-radius: 10px;
    margin: 0 auto;
    margin-top: 16%;
    box-shadow: 0 0 15px #eee8c0;
    text-align: center;
    padding: 15px;
  }
  .goback{
    float: right;
    color: #fff;
    cursor: pointer;
    font-size: 2vh;
  }
  .modal-header{
    margin-top: 25px;
    font-size: 2.5vh;
    font-weight: 600;
    color: #FFFFFF;
    font-family: 宋体;
  }
  .modal-main{
    width: 100%;
    height: 40%;
  }
  .titleface{
    font-size: 1vh;
    color: white;
  }
</style>




// WEBPACK FOOTER //
// src/pages/homePageAssembly/toollogin.vue